
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(382|509|727|810|967)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
